import { useNavigate } from "react-router-dom";
import { DATA, C, FONT_HEAD, FONT_MONO } from "../data";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      position: "relative", padding: "4rem 2rem", overflow: "hidden",
    }}>
      {/* Background grid */}
      <div style={{
        position: "absolute", inset: 0, pointerEvents: "none",
        backgroundImage: `linear-gradient(${C.gridLine} 1px, transparent 1px), linear-gradient(90deg, ${C.gridLine} 1px, transparent 1px)`,
        backgroundSize: "60px 60px",
      }} />

      {/* Glow orb */}
      <div style={{
        position: "absolute", top: "20%", left: "50%", transform: "translateX(-50%)",
        width: "600px", height: "300px",
        background: "radial-gradient(ellipse, rgba(0,212,255,0.06), transparent 70%)",
        pointerEvents: "none",
      }} />

      <div className="anim-fadeup" style={{ textAlign: "center", maxWidth: "780px", position: "relative" }}>
        <div style={{
          width: "120px", height: "120px", borderRadius: "50%",
          border: `3px solid ${C.accent}`,
          margin: "0 auto 2rem", overflow: "hidden",
          boxShadow: `0 0 30px rgba(0,212,255,0.3)`,
        }}>
          <img
            src={DATA.foto}
            alt="Profile"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
        <div style={{
          fontFamily: FONT_MONO, fontSize: "0.78rem", color: C.accent,
          letterSpacing: "5px", marginBottom: "1.8rem", opacity: 0.7,
        }}>
          {"HELLO, WORLD — WELCOME TO MY PORTFOLIO"}
        </div>

        <h1 className="anim-glow" style={{
          fontFamily: FONT_HEAD, fontWeight: 800, lineHeight: 1.05,
          fontSize: "clamp(3.2rem,9vw,6.5rem)", color: "#fff", marginBottom: "1.2rem",
        }}>
          {DATA.name}
        </h1>

        <div style={{
          fontFamily: FONT_HEAD, fontWeight: 600,
          fontSize: "clamp(1.1rem,2.5vw,1.7rem)", color: C.accent, marginBottom: "1.5rem",
        }}>
          {DATA.title}
        </div>

        <p style={{
          fontFamily: FONT_MONO, fontSize: "0.95rem", color: C.muted,
          maxWidth: "480px", margin: "0 auto 3rem", lineHeight: 1.9,
        }}>
          {DATA.tagline}
        </p>

        <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
          <button className="cta-primary" onClick={() => navigate("/projects")} style={{
            background: C.accent, color: C.bg, border: "none",
            padding: "0.8rem 2.2rem", fontFamily: FONT_MONO, fontSize: "0.8rem",
            fontWeight: 600, letterSpacing: "1.5px", borderRadius: "4px", cursor: "pointer",
          }}>
            VIEW PROJECTS →
          </button>
          <button className="cta-outline" onClick={() => navigate("/contact")} style={{
            background: "transparent", color: C.accent,
            border: `1px solid ${C.accentBorder}`, padding: "0.8rem 2.2rem",
            fontFamily: FONT_MONO, fontSize: "0.8rem", letterSpacing: "1.5px",
            borderRadius: "4px", cursor: "pointer",
          }}>
            CONTACT ME
          </button>
        </div>

        {/* Stats */}
        <div style={{
          display: "flex", gap: "3rem", justifyContent: "center",
          marginTop: "4rem", flexWrap: "wrap",
        }}>
          {[
            { num: DATA.projects.length + "+", label: "Projects" },
            { num: DATA.certifications.length + "+", label: "Certifications" },
            { num: DATA.skills.reduce((a, s) => a + s.items.length, 0) + "+", label: "Skills" },
          ].map(({ num, label }) => (
            <div key={label} style={{ textAlign: "center" }}>
              <div style={{ fontFamily: FONT_HEAD, fontWeight: 800, fontSize: "2rem", color: C.accent }}>
                {num}
              </div>
              <div style={{ fontFamily: FONT_MONO, fontSize: "0.72rem", color: C.muted, letterSpacing: "2px" }}>
                {label.toUpperCase()}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
